import * as React from "react";
import {translate} from "react-i18next";

// redux
import {connect} from "react-redux";

// router
import {RouteComponentProps} from "react-router-dom";

// services
import {
    GroupDto,
    RoleDto,
    ResourceListOfGroupDto,
    ResourceListOfRoleDto,
    ResourceListOfModelyearDto,
    CnrDto,
    ResourceListOfUserDto,
    ResourceListOfProMTGroupDto, ProMTGroupDto, UserDto,
} from "../../../../services/Client";

// components
import Button from "../../../../components/Button";
import TextField from "../../../../components/TextField";

import {getDtoArray} from "../../AdminUtils";
import GeneralActions from "../../../../redux/actions/GeneralActions";
import AdminViewActions from "../../../../redux/actions/AdminViewActions";
import {Checkbox, Dropdown, Icon, Modal, Table} from "semantic-ui-react";
import HATEOASClient from "../../../../services/HATEOASClient";
import {
    selectClient, selectCnrList,
    selectGroups,
    selectModelyears, selectProMTGroups,
    selectRoles, selectTypefamilyMap, selectUsers
} from "../../../../redux/selectors";
import {compose, Dispatch} from "redux";
import {ITranslatedComponent, ITypefamilyMap} from "../../../../redux/reducers/generalReducer";
import {IReduxState} from "../../../../redux/IReduxState";
import Textfield from "../../../../components/TextField";
import ProMTGroupsTable from "./ProMTGroupsTable";

enum AccessRightsFilter {
    SHOW_ALL = 1,
    ACCESS_RIGHTS = 2,
    NO_ACCESS_RIGHTS = 3
}

interface IMapStateToProps {
    client: HATEOASClient;
    groups?: ResourceListOfGroupDto;
    proMTGroups: ResourceListOfProMTGroupDto;
    roles?: ResourceListOfRoleDto;
    users?: ResourceListOfUserDto;
    modelYears?: ResourceListOfModelyearDto;
    typefamilyMap?: ITypefamilyMap;
    cnrList?: CnrDto[];
}

interface IMapDispatchToProps {
    addTranslationLocation: () => void;
    getGroups: (setLoading: (flag: boolean) => void) => void;
    getRoles: (setLoading: (flag: boolean) => void) => void;
    getUsers: (setLoading: (flag: boolean) => void) => void;
    getProMTGroups: (setLoading: (flag: boolean) => void) => void;
    createProMTGroup: (groupName: string, setLoading: (flag: boolean) => void) => void;
    updateProMTGroup: (oldGroup: ProMTGroupDto, newGroup: ProMTGroupDto, setLoading: (flag: boolean) => void) => void;
    deleteProMTGroup: (proMTGroupDto: ProMTGroupDto, setLoading: (flag: boolean) => void) => void;
}

interface IOwnProps {

}

interface IProMTGroupsViewProps extends IOwnProps, IMapStateToProps, IMapDispatchToProps, ITranslatedComponent, RouteComponentProps<any> {
}

interface IProMTGroupsViewState {
    /** Whether or not we are waiting for a response from the back end. */
    loadingProMTGroups: boolean;

    /** Whether or not we are waiting for a response from the back end. */
    loadingRoles: boolean;

    /** Whether or not we are waiting for a response from the back end. */
    loadingGroups: boolean;

    /** Whether or not we are waiting for a response from the back end. */
    loadingUsers: boolean;

    /** proMTGroupName used for creation */
    proMTGroupName?: string;

    /** Group name filter. */
    groupNameFilter: string | undefined;

    /** Filter based on group view access rights */
    accessRightsFilter: AccessRightsFilter;

    /** Whether or not to show the group creation dialog. */
    showGroupCreationDialog: boolean;

    /** Flag for displaying/hiding the access view rights for all groups  */
    showAllViewAccessRights: boolean;

    /** All roles that are assigned to groups */
    filterValues: Map<number, RoleDto>;

    /** Filter based on group view roles */
    roleFilter: string[];

    /** Groups that match the current filter. */
    filteredGroups: ProMTGroupDto[];

    roleFilterAllSelected: boolean;
}

class ProMTGroupsView extends React.Component<IProMTGroupsViewProps, IProMTGroupsViewState> {
    constructor(props: IProMTGroupsViewProps) {
        super(props);

        this.state = {
            loadingProMTGroups: false,
            loadingRoles: false,
            loadingGroups: false,
            loadingUsers: false,
            proMTGroupName: undefined,
            groupNameFilter: undefined,
            showGroupCreationDialog: false,
            showAllViewAccessRights: false,
            accessRightsFilter: AccessRightsFilter.SHOW_ALL,
            filterValues: this.renderFilterValues(),
            roleFilter: [],
            filteredGroups: getDtoArray<ProMTGroupDto>(this.props.proMTGroups),
            roleFilterAllSelected: false
        };
    }

    componentDidMount() {
        this.props.addTranslationLocation();

        if (!this.props.groups) {
            this.props.getGroups((flag: boolean) => this.setState({loadingGroups: flag}));
        }

        if (!this.props.roles) {
            // we need a list of all available roles for selection in the groups table.
            this.props.getRoles((flag: boolean) => this.setState({loadingRoles: flag}));
        }

        if (!this.props.users) {
            // we need a list of all available users for selection in the groups table.
            this.props.getUsers((flag: boolean) => this.setState({loadingUsers: flag}));
        }

        if (!this.props.proMTGroups.elements) {
            this.props.getProMTGroups((flag: boolean) => this.setState({loadingProMTGroups: flag}));
        }
    }

    componentDidUpdate (prevProps: IProMTGroupsViewProps, prevState: IProMTGroupsViewState) {
        if ((this.props.proMTGroups !== prevProps.proMTGroups)) {
            this.setState({filteredGroups: getDtoArray<ProMTGroupDto>(this.props.proMTGroups), filterValues: this.renderFilterValues()});
        }

        if (this.state.groupNameFilter !== prevState.groupNameFilter) {
            const filterValue = this.state.groupNameFilter !== "" ? this.state.groupNameFilter : undefined;
            let filteredDtos = this.applyFilter(getDtoArray<ProMTGroupDto>(this.props.proMTGroups));

            this.setState({groupNameFilter: filterValue, filteredGroups: filteredDtos});
        }
    }
    applyUserDeptGroupNameFilter = (filterLowerCase: string, filteredDtos: ProMTGroupDto[]): ProMTGroupDto[] => {
        return filteredDtos.filter(dto => dto.groupName.toLowerCase().includes(filterLowerCase)
            || (dto.assignedUsers ? dto.assignedUsers.some(user => (user.name ? user.name.toLowerCase().includes(filterLowerCase) : false)
                || (user.department ? user.department.toLocaleLowerCase().includes(filterLowerCase) : false)) : false));
    }

    applyFilter = (dtos: ProMTGroupDto[]): ProMTGroupDto[] => {
        let filteredDtos = dtos;
        if (this.state.groupNameFilter) {
            const filterLowerCase = this.state.groupNameFilter.toLowerCase();
            filteredDtos = this.applyUserDeptGroupNameFilter(filterLowerCase, filteredDtos);
        }

        if (this.state.accessRightsFilter !== AccessRightsFilter.SHOW_ALL) {
            filteredDtos = filteredDtos.filter(dto =>
                ((dto.assignedCnrs !== undefined && dto.assignedCnrs.length > 0) ||
                    (dto.assignedModelyears !== undefined && dto.assignedModelyears.length > 0))
                === (this.state.accessRightsFilter === AccessRightsFilter.ACCESS_RIGHTS));
        }

        return filteredDtos;
    }

    applyRoleFilter = (dtos: ProMTGroupDto[], groupNameFilter: string | undefined, roleFilter: string[]): ProMTGroupDto[] => {
        let filteredDtos = dtos;

        if (groupNameFilter) {
            const filterLowerCase = groupNameFilter.toLowerCase();
            filteredDtos = this.applyUserDeptGroupNameFilter(filterLowerCase, filteredDtos);
        }

        if (roleFilter.length > 0) {
            filteredDtos = filteredDtos.filter((dto: ProMTGroupDto) => {
                let test: boolean = false;
                if (dto.assignedRoles && dto.assignedRoles.length > 0) {
                    test = dto.assignedRoles.some((assignedRole: RoleDto) => assignedRole
                        ? roleFilter.some(filter => assignedRole ? assignedRole.name === filter : false)
                        : false
                    );
                }
                return test;
            });
        }

        return filteredDtos;
    }

    isLoading = () => {
        return this.state.loadingGroups || this.state.loadingProMTGroups || this.state.loadingRoles || this.state.loadingUsers;
    }

    renderAccessRightsFilter = (): JSX.Element => (
        <Dropdown
            id={'groups-access-rights-filter'}
            clearable={false}
            closeOnChange={true}
            selection={true}
            disabled={this.isLoading()}
            className={this.state.accessRightsFilter === AccessRightsFilter.ACCESS_RIGHTS ? 'groups-active-access-rights'
                : `color--white ${this.state.accessRightsFilter === AccessRightsFilter.NO_ACCESS_RIGHTS ? 'font-weight--bold' : ''}`}
            icon={<Icon name={'filter'} style={{float: 'left'}} />}
            options={[
                {
                    key: AccessRightsFilter.SHOW_ALL,
                    text: this.props.t("SHOW_ALL_GROUPS"),
                    value: AccessRightsFilter.SHOW_ALL
                },
                {
                    key: AccessRightsFilter.ACCESS_RIGHTS,
                    text: this.props.t("ACCESS_RIGHTS_GROUPS"),
                    value: AccessRightsFilter.ACCESS_RIGHTS
                },
                {
                    key: AccessRightsFilter.NO_ACCESS_RIGHTS,
                    text: this.props.t("NO_ACCESS_RIGHTS_GROUPS"),
                    value: AccessRightsFilter.NO_ACCESS_RIGHTS
                }
            ]}
            value={this.state.accessRightsFilter}
            onChange={(e, v) => this.setState({accessRightsFilter: v.value as AccessRightsFilter})}
        />
    )

    renderRolesFilter(): JSX.Element {
        return (
            <Dropdown
                id={'access-tab-role-filter'}
                icon={<Icon name={'filter'} style={{float: 'left'}} />}
                text={this.props.t("ROLES")}
                disabled={this.state.accessRightsFilter === AccessRightsFilter.NO_ACCESS_RIGHTS || this.isLoading()}
                scrolling={true}
            >
                <Dropdown.Menu>
                    <Dropdown.Item
                        onClick={(e) => {
                            let {roleFilter} = this.state;
                            const filterValues = Array.from(this.state.filterValues.values());

                            e.stopPropagation();

                            this.state.roleFilterAllSelected
                                ? roleFilter = []
                                : filterValues.forEach(filter => roleFilter.push(filter.name));

                            let filteredDtos = this.applyRoleFilter(getDtoArray<ProMTGroupDto>(this.props.proMTGroups), this.state.groupNameFilter, roleFilter);

                            this.setState({filteredGroups: filteredDtos, roleFilter: roleFilter, roleFilterAllSelected: !this.state.roleFilterAllSelected});
                        }}
                    >
                        <Checkbox
                            checked={this.state.roleFilterAllSelected}
                            label={this.props.t("GLOBAL:SELECT_ALL")}
                            className={'disableClickEvents'}
                        />
                    </Dropdown.Item>
                    <Dropdown.Header
                        icon='tags'
                        content={this.props.t("GLOBAL:FILTER_ROLES")}
                    />
                    {this.state.filterValues && Array.from(this.state.filterValues.values()).sort((a, b) => a.name.localeCompare(b.name)).map((key: RoleDto) => {
                        return (
                            <Dropdown.Item
                                key={key.objectId}
                                onClick={(e) => {
                                    let {roleFilter} = this.state;

                                    e.stopPropagation();

                                    !roleFilter.includes(key.name)
                                        ? roleFilter.push(key.name)
                                        : roleFilter = roleFilter.filter(filter => filter !== key.name);

                                    const roleFilterAllSelected = roleFilter.length === this.state.filterValues.size ? true : false;

                                    let filteredDtos = this.applyRoleFilter(getDtoArray<ProMTGroupDto>(this.props.proMTGroups), this.state.groupNameFilter, roleFilter);

                                    this.setState({filteredGroups: filteredDtos, roleFilter, roleFilterAllSelected});
                                }}
                            >
                                <Checkbox
                                    checked={this.state.roleFilter.includes(key.name)}
                                    label={key.name}
                                    className={'disableClickEvents'}
                                />
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown.Menu>
            </Dropdown>
        );

    }

    renderFilterValues(): Map<number, RoleDto> {
        let filterValues: Map<number, RoleDto> = new Map<number, RoleDto>();
        getDtoArray<ProMTGroupDto>(this.props.proMTGroups).forEach((group: ProMTGroupDto) => {
            if (group.assignedRoles) {
                group.assignedRoles.forEach((assignedRole: RoleDto) => {
                    if (assignedRole) {
                        if (!filterValues.has(assignedRole.objectId)) {
                            filterValues.set(assignedRole.objectId, assignedRole);
                        }
                    }
                });
            }
        });

        return filterValues;
    }

    createGroup = () => {
        if (this.state.proMTGroupName && this.state.proMTGroupName.trim() !== "") {
            this.props.createProMTGroup(this.state.proMTGroupName, (flag: boolean) => this.setState({loadingProMTGroups: flag}));
            this.setState({showGroupCreationDialog: false});
        }
    }

    render() {
        const groups = getDtoArray<GroupDto>(this.props.groups);
        const roles = getDtoArray<RoleDto>(this.props.roles);
        const users = getDtoArray<UserDto>(this.props.users);
        let filteredDtos = this.state.filteredGroups;

        return (
            <>
                {this.state.showGroupCreationDialog &&
                    <Modal open={true} style={{"marginTop": 0}}>
                        <Modal.Header>{this.props.t("ADD_PROMT_GROUP")}</Modal.Header>
                        <Modal.Content>
                            <Table definition={true}>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            {this.props.t("GROUP_NAME")}
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Textfield
                                                placeholder={this.props.t("ENTER_GROUP_NAME")}
                                                onChange={(event: React.FormEvent<{}>, newValue: string) => {
                                                    this.setState({ proMTGroupName: newValue });
                                                }}
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button
                                icon={"checkmark"}
                                disabled={!this.state.proMTGroupName || this.state.proMTGroupName.trim() === ""}
                                onClick={this.createGroup}
                            />
                            <Button
                                icon={"ban"}
                                onClick={() => this.setState({showGroupCreationDialog: false})}
                            />
                        </Modal.Actions>
                    </Modal>
                }

                <div style={{display: 'flex'}}>
                    {this.props.proMTGroups && this.props.client.POST_proMTGroup(this.props.proMTGroups).canExecute() &&
                        <Button
                            label={this.props.t("ADD_PROMT_GROUP")}
                            labelPosition="after"
                            icon={"add"}
                            disabled={this.isLoading()}
                            onClick={() => this.setState({showGroupCreationDialog: true})}
                        />
                    }
                    {this.props.proMTGroups && this.props.client.POST_proMTGroup(this.props.proMTGroups).canExecute() &&
                        <Button
                            label={this.props.t(this.state.showAllViewAccessRights ? "HIDE_ALL_VIEW_ACCESS_RIGHTS" : "SHOW_ALL_VIEW_ACCESS_RIGHTS")}
                            labelPosition={"after"}
                            icon={this.state.showAllViewAccessRights ? "hide" : "unhide"}
                            disabled={this.isLoading()}
                            onClick={() => this.setState({showAllViewAccessRights: !this.state.showAllViewAccessRights})}
                        />
                    }
                    {this.props.groups && this.renderAccessRightsFilter()}
                    {this.props.proMTGroups && this.renderRolesFilter()}
                    <Button
                        label={this.props.t("RELOAD")}
                        labelPosition="after"
                        icon={"refresh"}
                        disabled={this.isLoading()}
                        onClick={() => {
                            this.props.getUsers((flag) => this.setState({loadingUsers: flag}));
                            this.props.getGroups((flag) => this.setState({loadingGroups: flag}));
                            this.props.getRoles((flag) => this.setState({loadingRoles: flag}));
                            this.props.getProMTGroups((flag) => this.setState({loadingProMTGroups: flag}));
                        }}
                    />
                </div>
                <br />

                <TextField
                    placeholder={this.props.t("FILTER_BY_NAME")}
                    value={this.state.groupNameFilter}
                    onChange={(event: React.FormEvent<{}>, newValue: string) =>
                        this.setState({groupNameFilter: newValue !== "" ? newValue : undefined})}
                />

                <ProMTGroupsTable
                    proMTGroups={filteredDtos}
                    groups={groups}
                    roles={roles}
                    users={users}
                    modelyears={this.props.modelYears && this.props.modelYears.elements ? this.props.modelYears.elements : []}
                    typefamiliesMap={this.props.typefamilyMap || {}}
                    cnrs={this.props.cnrList ? this.props.cnrList : []}
                    loading={this.isLoading()}
                    showAllViewAccessRights={this.state.showAllViewAccessRights}
                    optionalControls={{
                        canUpdateGroup: dto => this.props.client.PATCH_proMTGroup(dto).canExecute(),
                        canDeleteGroup: dto => this.props.client.DELETE_proMTGroup(dto).canExecute(),
                    }}
                    onUpdateGroup={(oldDto: ProMTGroupDto, newDto: ProMTGroupDto) =>
                        this.props.updateProMTGroup(oldDto, newDto, (flag: boolean) => this.setState({loadingProMTGroups: flag}))}
                    onDeleteGroup={(proMTGroupDto: ProMTGroupDto) =>
                        this.props.deleteProMTGroup(proMTGroupDto,(flag: boolean) => this.setState({loadingProMTGroups: flag}))}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    client: selectClient(state),
    groups: selectGroups(state),
    roles: selectRoles(state),
    users: selectUsers(state),
    modelYears: selectModelyears(state),
    typefamilyMap: selectTypefamilyMap(state),
    cnrList: selectCnrList(state),
    proMTGroups: selectProMTGroups(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: IProMTGroupsViewProps): IMapDispatchToProps => ({
    addTranslationLocation: () => dispatch(GeneralActions.AddTranslationLocation({pattern: "admin/groups", substitutes: "Groups Management"})),
    getGroups: (setLoading: (flag: boolean) => void) => dispatch(AdminViewActions.GetGroups(ownProps.t, setLoading)),
    getRoles: (setLoading: (flag: boolean) => void) => dispatch(AdminViewActions.GetRoles(ownProps.t, setLoading)),
    getUsers: (setLoading: (flag: boolean) => void) => dispatch(AdminViewActions.GetUsers(ownProps.t, setLoading)),
    getProMTGroups: (setLoading: (flag: boolean) => void) => dispatch(AdminViewActions.GetProMTGroups(ownProps.t, setLoading)),
    createProMTGroup: (groupName: string, setLoading: (flag: boolean) => void) =>
        dispatch(AdminViewActions.CreateProMTGroup(groupName, ownProps.t, setLoading)),
    updateProMTGroup: (oldGroup: ProMTGroupDto, newGroup: ProMTGroupDto, setLoading: (flag: boolean) => void) =>
        dispatch(AdminViewActions.UpdateProMTGroup(oldGroup, newGroup, ownProps.t, setLoading)),
    deleteProMTGroup: (proMTGroupDto: ProMTGroupDto, setLoading: (flag: boolean) => void) =>
        dispatch(AdminViewActions.DeleteProMTGroup(proMTGroupDto, ownProps.t, setLoading)),
});

export default compose<React.ComponentType<IOwnProps>>(
    translate("ADMIN_VIEW"),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(ProMTGroupsView);



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/ProMTGroupsTab/ProMTGroupsView.tsx